import { generatePath } from 'react-router-dom'
import { ROUTE_BASE } from 'apps-common'

export const generatePathWithRoot = (path: string, params?: any): string =>
  `/${ROUTE_BASE.learner}${generatePath(path, params)}`
